import React from 'react'
import { codeErrorResponse } from 'functions/codeError'
import ModalPortal from 'components/Modal'

export function ModalError(props){
    const {
        errorCode,
        section,
        handleClose,
        message
    } = props

    return(
        <ModalPortal type="btn" onClose={handleClose} >
            <p>Código de error: {errorCode.codMen}</p>
            <br />
            <p>{!message
                ? codeErrorResponse(errorCode.codMen, section)
                : message
            }</p>
        </ModalPortal>
    )
}